export const auditQueryKeys = {
  all: ["audit"],
  lists: () => [...auditQueryKeys.all, "list"],
  list: (filters) => [...auditQueryKeys.lists(), filters],
  meta: () => [...auditQueryKeys.all, "meta"],
};
